import config from '../../assets/js/conf/config'
import request from '../../assets/js/utils/request'
import { uploadDirectOss } from '@/assets/js/utils/ossDirectUpload'

const titleBase = config.baseApi + '/merchant/doudian/title-batch'
const batchBase = config.baseApi + '/merchant/doudian/batch'
const shortTitleBase = config.baseApi + '/merchant/doudian/short-title-batch'
const brandBase = config.baseApi + '/merchant/doudian/brand-batch'
const attributeBase = config.baseApi + '/merchant/doudian/attribute-batch'
const huohaoBase = config.baseApi + '/merchant/doudian/huohao-batch'
const fabricBase = config.baseApi + '/merchant/doudian/fabric-batch'

export const previewDoudianFabricBatch = (data) => request.post(fabricBase + '/preview', data).then(shortTitleResult)
export const createDoudianFabricBatch = (data) => request.post(fabricBase, data).then(shortTitleResult)
export const getDoudianFabricMaterials = (data) => request.post(fabricBase + '/materials', data).then(shortTitleResult)
export const uploadDoudianFabricSource = (file) => uploadDirectOss(file, { policyUrl: fabricBase + '/upload-policy' })

const shortTitleResult = (response) => {
  if (!response || Number(response.code) !== 200) throw new Error(response?.message || '请求失败')
  return response
}

export const previewDoudianShortTitleBatch = (data) => request.post(shortTitleBase + '/preview', data).then(shortTitleResult)
export const createDoudianShortTitleBatch = (data) => request.post(shortTitleBase, data).then(shortTitleResult)
export const getDoudianBatchBrands = (data) => request.post(brandBase + '/brands', data).then(shortTitleResult)
export const getDoudianBrandCoverage = (data) => request.post(brandBase + '/coverage', data).then(shortTitleResult)
export const previewDoudianBrandBatch = (data) => request.post(brandBase + '/preview', data).then(shortTitleResult)
export const createDoudianBrandBatch = (data) => request.post(brandBase, data).then(shortTitleResult)
export const previewDoudianHuohaoBatch = (data) => request.post(huohaoBase + '/preview', data).then(shortTitleResult)
export const createDoudianHuohaoBatch = (data) => request.post(huohaoBase, data).then(shortTitleResult)
export const restoreDoudianHuohaoBatch = (id) => request.post(huohaoBase + '/' + id + '/restore', {}).then(shortTitleResult)

const statusBatchBase = config.baseApi + '/merchant/doudian/status-batch'
const timerStatusBatchBase = config.baseApi + '/merchant/doudian/timer-status-batch'
const shelfBase = (feature) => (feature === 'timer' ? timerStatusBatchBase : statusBatchBase)
export const previewDoudianShelfBatch = (feature, data) => request.post(shelfBase(feature) + '/preview', data).then(shortTitleResult)
export const createDoudianShelfBatch = (feature, data) => request.post(shelfBase(feature), data).then(shortTitleResult)
export const restoreDoudianShelfBatch = (id) => request.post(statusBatchBase + '/' + id + '/restore', {}).then(shortTitleResult)

export const previewDoudianTitleBatch = (data) => request.post(titleBase + '/preview', data)

export const createDoudianTitleBatch = (data) => request.post(titleBase, data)
export const getDoudianTitleBatchList = (data) => request.get(titleBase, data)
export const getDoudianTitleBatchDetail = (id, data) => request.get(titleBase + '/' + id + '/details', data)
export const getDoudianBatchList = (data) => request.get(batchBase, data)
export const getDoudianBatchDetail = (id, data) => request.get(batchBase + '/' + id + '/details', data)
export const cancelDoudianBatch = (id) => request.post(batchBase + '/' + id + '/cancel', {})

export const getDoudianCategories = (data) => request.get(config.baseApi + '/merchant/product/category/list', data)
export const getAuthSuccessShopList = () => request.get(config.baseApi + '/merchant/shop/getAuthSuccessShopList')
export const getProductSelectorProducts = (data) => request.post(config.baseApi + '/merchant/product-selector/products', data)

export const getDoudianAttributeProperties = (data) => request.post(attributeBase + '/properties', data).then(shortTitleResult)
export const previewDoudianAttributeBatch = (data) => request.post(attributeBase + '/preview', data).then(shortTitleResult)
export const createDoudianAttributeBatch = (data) => request.post(attributeBase, data).then(shortTitleResult)
export const restoreDoudianAttributeBatch = (id) => request.post(attributeBase + '/' + id + '/restore', {}).then(shortTitleResult)
